import { render, staticRenderFns } from "./CountRegistreringer.vue?vue&type=template&id=3e63d232&scoped=true&"
import script from "./CountRegistreringer.vue?vue&type=script&lang=js&"
export * from "./CountRegistreringer.vue?vue&type=script&lang=js&"
import style0 from "./CountRegistreringer.vue?vue&type=style&index=0&id=3e63d232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e63d232",
  null
  
)

export default component.exports